import {
    Button,
    Container,
    TextField,
    Typography,
    Box,
} from "@mui/material";
import React, { Fragment, useEffect, useState, useRef } from "react";
import LoginImg from "../../assets/Login.png";
import JSI from "../../assets/JSI.png";
import { Stack } from "@mui/material";

export const LoginPage = () => {
    const [loading, setLoading] = useState(false);
    const hasFetched = useRef(false)
    const handleLogin = () => {
        setLoading(true);
    };

    const submitForm = async () => {
        window.location.href = "/login";
    };
    useEffect(() => {
        if (loading) {
            submitForm();
        }
    }, [loading])
    return (
        <Fragment>
            <Container maxWidth="sm">
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="100vh"
                    width="100%"
                >
                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        alignItems="center"
                        justifyContent="center"
                        columnGap={2}
                        width="100%"
                    >
                        <Box width="100%" display="flex" justifyContent="center">
                            <img
                                src={LoginImg}
                                alt="Logo"
                                style={{
                                    cursor: "pointer",
                                    width: "100%",
                                    maxWidth: "300px",
                                }}
                            />
                        </Box>
                        <Box
                            width="100%"
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            gap={2}
                        >
                            <img
                                src={JSI}
                                alt="Logo"
                                style={{
                                    width: "20%",
                                    maxWidth: "20%",
                                    cursor: "pointer",
                                }}
                            />

                            <Button
                                variant="contained"
                                //color="primary"
                                size="large"
                                onClick={handleLogin}
                                disabled={loading}
                                sx={{ backgroundColor: "#0066FF", borderRadius: "8px" }}
                            >
                                {loading ? "Logging in..." : "Login"}
                            </Button>
                        </Box>
                    </Stack>
                </Box>
            </Container>
        </Fragment>
    );
};
